import { render, staticRenderFns } from "./grouplist.vue?vue&type=template&id=58ab58f0&scoped=true"
import script from "./grouplist.vue?vue&type=script&lang=js"
export * from "./grouplist.vue?vue&type=script&lang=js"
import style0 from "./grouplist.vue?vue&type=style&index=0&id=58ab58f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab58f0",
  null
  
)

export default component.exports